// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Apollo = require("../../../shared/src/bindings/Apollo.bs.js");
var OTPUtils = require("../../../shared/src/OTPUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_Jwt = require("../../../shared/src/types/CommonTypes_Jwt.bs.js");
var CommonTypes_City = require("../../../shared/src/types/CommonTypes_City.bs.js");
var CommonTypes_Guid = require("../../../shared/src/types/CommonTypes_Guid.bs.js");
var CommonTypes_Email = require("../../../shared/src/types/CommonTypes_Email.bs.js");
var CommonTypes_ZipCode = require("../../../shared/src/types/CommonTypes_ZipCode.bs.js");
var CommonTypes_User_Name = require("../../../shared/src/types/CommonTypes_User_Name.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Business_PromoCode = require("../../../shared/src/types/business/CommonTypes_Business_PromoCode.bs.js");
var CommonTypes_Worker_ReferralPromoCode = require("../../../shared/src/types/worker/CommonTypes_Worker_ReferralPromoCode.bs.js");
var CommonTypes_Business_LoginOrSignupResult = require("../../../shared/src/types/business/CommonTypes_Business_LoginOrSignupResult.bs.js");

var Raw = {};

var query = "query emailIsAvailable($email: Email!)  {\nemailIsAvailable(email: $email)  \n}\n";

function parse(value) {
  var value$1 = value.emailIsAvailable;
  return {
          emailIsAvailable: !(value$1 == null) ? value$1 : undefined
        };
}

function serialize(value) {
  var value$1 = value.emailIsAvailable;
  var emailIsAvailable = value$1 !== undefined ? value$1 : null;
  return {
          emailIsAvailable: emailIsAvailable
        };
}

function serializeVariables(inp) {
  return {
          email: inp.email
        };
}

function makeVariables(email, param) {
  return {
          email: email
        };
}

function variables(email) {
  return Json.Encode.object_({
              hd: [
                "email",
                Curry._1(CommonTypes_Email.encode, email)
              ],
              tl: /* [] */0
            });
}

function decode(param) {
  return param.emailIsAvailable;
}

var Definition = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  variables: variables,
  decode: decode
};

var include = Apollo.CreateQuery({
      Raw: Raw,
      query: query,
      variables: variables,
      parse: parse,
      decode: decode
    });

var CheckEmailAvailable_graphqlQueryAST = include.graphqlQueryAST;

var CheckEmailAvailable_query = include.query;

var CheckEmailAvailable_queryStoreError = include.queryStoreError;

var CheckEmailAvailable_queryResult = include.queryResult;

var CheckEmailAvailable_queryAsyncData = include.queryAsyncData;

var CheckEmailAvailable_queryAsyncDataStoreError = include.queryAsyncDataStoreError;

var CheckEmailAvailable_queryAsyncResult = include.queryAsyncResult;

var CheckEmailAvailable = {
  Definition: Definition,
  graphqlQueryAST: CheckEmailAvailable_graphqlQueryAST,
  query: CheckEmailAvailable_query,
  queryStoreError: CheckEmailAvailable_queryStoreError,
  queryResult: CheckEmailAvailable_queryResult,
  queryAsyncData: CheckEmailAvailable_queryAsyncData,
  queryAsyncDataStoreError: CheckEmailAvailable_queryAsyncDataStoreError,
  queryAsyncResult: CheckEmailAvailable_queryAsyncResult
};

var Raw$1 = {};

var query$1 = "query phoneNumberIsAvailable($phoneNumber: PhoneNumber!)  {\nphoneNumberIsAvailable(phoneNumber: $phoneNumber)  \n}\n";

function parse$1(value) {
  var value$1 = value.phoneNumberIsAvailable;
  return {
          phoneNumberIsAvailable: !(value$1 == null) ? value$1 : undefined
        };
}

function serialize$1(value) {
  var value$1 = value.phoneNumberIsAvailable;
  var phoneNumberIsAvailable = value$1 !== undefined ? value$1 : null;
  return {
          phoneNumberIsAvailable: phoneNumberIsAvailable
        };
}

function serializeVariables$1(inp) {
  return {
          phoneNumber: inp.phoneNumber
        };
}

function makeVariables$1(phoneNumber, param) {
  return {
          phoneNumber: phoneNumber
        };
}

function variables$1(phoneNumber) {
  return Json.Encode.object_({
              hd: [
                "phoneNumber",
                CommonTypes_LongPhoneNumber.encode(phoneNumber)
              ],
              tl: /* [] */0
            });
}

function decode$1(param) {
  return param.phoneNumberIsAvailable;
}

var Definition$1 = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  variables: variables$1,
  decode: decode$1
};

var include$1 = Apollo.CreateQuery({
      Raw: Raw$1,
      query: query$1,
      variables: variables$1,
      parse: parse$1,
      decode: decode$1
    });

var CheckPhoneNumberAvailable_graphqlQueryAST = include$1.graphqlQueryAST;

var CheckPhoneNumberAvailable_query = include$1.query;

var CheckPhoneNumberAvailable_queryStoreError = include$1.queryStoreError;

var CheckPhoneNumberAvailable_queryResult = include$1.queryResult;

var CheckPhoneNumberAvailable_queryAsyncData = include$1.queryAsyncData;

var CheckPhoneNumberAvailable_queryAsyncDataStoreError = include$1.queryAsyncDataStoreError;

var CheckPhoneNumberAvailable_queryAsyncResult = include$1.queryAsyncResult;

var CheckPhoneNumberAvailable = {
  Definition: Definition$1,
  graphqlQueryAST: CheckPhoneNumberAvailable_graphqlQueryAST,
  query: CheckPhoneNumberAvailable_query,
  queryStoreError: CheckPhoneNumberAvailable_queryStoreError,
  queryResult: CheckPhoneNumberAvailable_queryResult,
  queryAsyncData: CheckPhoneNumberAvailable_queryAsyncData,
  queryAsyncDataStoreError: CheckPhoneNumberAvailable_queryAsyncDataStoreError,
  queryAsyncResult: CheckPhoneNumberAvailable_queryAsyncResult
};

var Raw$2 = {};

var query$2 = "mutation sendPhoneNumberCode($phoneNumber: String!)  {\nsendPhoneNumberCode(input: {phoneNumber: $phoneNumber})  {\nsuccess  \n}\n\n}\n";

function parse$2(value) {
  var value$1 = value.sendPhoneNumberCode;
  return {
          sendPhoneNumberCode: !(value$1 == null) ? ({
                success: value$1.success
              }) : undefined
        };
}

function serialize$2(value) {
  var value$1 = value.sendPhoneNumberCode;
  var sendPhoneNumberCode;
  if (value$1 !== undefined) {
    var value$2 = value$1.success;
    sendPhoneNumberCode = {
      success: value$2
    };
  } else {
    sendPhoneNumberCode = null;
  }
  return {
          sendPhoneNumberCode: sendPhoneNumberCode
        };
}

function serializeVariables$2(inp) {
  return {
          phoneNumber: inp.phoneNumber
        };
}

function makeVariables$2(phoneNumber, param) {
  return {
          phoneNumber: phoneNumber
        };
}

function variables$2(phoneNumber) {
  return Json.Encode.object_({
              hd: [
                "phoneNumber",
                CommonTypes_LongPhoneNumber.encode(phoneNumber)
              ],
              tl: /* [] */0
            });
}

function decode$2(param) {
  var match = param.sendPhoneNumberCode;
  if (match !== undefined) {
    return Relude_Option.pure(match.success);
  }
  
}

var Definition$2 = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  variables: variables$2,
  decode: decode$2
};

var include$2 = Apollo.CreateMutation({
      Raw: Raw$2,
      query: query$2,
      variables: variables$2,
      parse: parse$2,
      decode: decode$2
    });

var SendVerifyCode_graphqlMutationAST = include$2.graphqlMutationAST;

var SendVerifyCode_mutate = include$2.mutate;

var SendVerifyCode_mutateStoreError = include$2.mutateStoreError;

var SendVerifyCode_mutateResult = include$2.mutateResult;

var SendVerifyCode_mutateResultStore = include$2.mutateResultStore;

var SendVerifyCode_mutateAsyncData = include$2.mutateAsyncData;

var SendVerifyCode_mutateAsyncResult = include$2.mutateAsyncResult;

var SendVerifyCode_mutateAsycResultApolloError = include$2.mutateAsycResultApolloError;

var SendVerifyCode = {
  Definition: Definition$2,
  graphqlMutationAST: SendVerifyCode_graphqlMutationAST,
  mutate: SendVerifyCode_mutate,
  mutateStoreError: SendVerifyCode_mutateStoreError,
  mutateResult: SendVerifyCode_mutateResult,
  mutateResultStore: SendVerifyCode_mutateResultStore,
  mutateAsyncData: SendVerifyCode_mutateAsyncData,
  mutateAsyncResult: SendVerifyCode_mutateAsyncResult,
  mutateAsycResultApolloError: SendVerifyCode_mutateAsycResultApolloError
};

var Raw$3 = {};

var query$3 = "mutation signupWorker($cityId: Int!, $code: String!, $email: String!, $firstName: String!, $lastName: String!, $phoneNumber: String!, $promoCode: String, $utmCampaign: String, $utmContent: String, $utmMedium: String, $utmSource: String, $utmTerm: String, $zipcode: String!)  {\nworkerSignup(input: {cityId: $cityId, code: $code, email: $email, firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, promoCode: $promoCode, utmCampaign: $utmCampaign, utmContent: $utmContent, utmMedium: $utmMedium, utmSource: $utmSource, utmTerm: $utmTerm, zipCode: $zipcode})  {\njwt  \n}\n\n}\n";

function parse$3(value) {
  var value$1 = value.workerSignup;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.jwt;
    tmp = {
      jwt: !(value$2 == null) ? Caml_option.some(CommonTypes_Jwt.GraphQL_API.parse(value$2)) : undefined
    };
  }
  return {
          workerSignup: tmp
        };
}

function serialize$3(value) {
  var value$1 = value.workerSignup;
  var workerSignup;
  if (value$1 !== undefined) {
    var value$2 = value$1.jwt;
    var jwt = value$2 !== undefined ? Curry._1(CommonTypes_Jwt.GraphQL_API.serialize, Caml_option.valFromOption(value$2)) : null;
    workerSignup = {
      jwt: jwt
    };
  } else {
    workerSignup = null;
  }
  return {
          workerSignup: workerSignup
        };
}

function serializeVariables$3(inp) {
  var a = inp.promoCode;
  var a$1 = inp.utmCampaign;
  var a$2 = inp.utmContent;
  var a$3 = inp.utmMedium;
  var a$4 = inp.utmSource;
  var a$5 = inp.utmTerm;
  return {
          cityId: inp.cityId,
          code: inp.code,
          email: inp.email,
          firstName: inp.firstName,
          lastName: inp.lastName,
          phoneNumber: inp.phoneNumber,
          promoCode: a !== undefined ? a : undefined,
          utmCampaign: a$1 !== undefined ? a$1 : undefined,
          utmContent: a$2 !== undefined ? a$2 : undefined,
          utmMedium: a$3 !== undefined ? a$3 : undefined,
          utmSource: a$4 !== undefined ? a$4 : undefined,
          utmTerm: a$5 !== undefined ? a$5 : undefined,
          zipcode: inp.zipcode
        };
}

function makeVariables$3(cityId, code, email, firstName, lastName, phoneNumber, promoCode, utmCampaign, utmContent, utmMedium, utmSource, utmTerm, zipcode, param) {
  return {
          cityId: cityId,
          code: code,
          email: email,
          firstName: firstName,
          lastName: lastName,
          phoneNumber: phoneNumber,
          promoCode: promoCode,
          utmCampaign: utmCampaign,
          utmContent: utmContent,
          utmMedium: utmMedium,
          utmSource: utmSource,
          utmTerm: utmTerm,
          zipcode: zipcode
        };
}

function variables$3(param) {
  var match = param.utmParams;
  return Json.Encode.object_({
              hd: [
                "cityId",
                Curry._1(CommonTypes_City.Id.encode, param.city.id)
              ],
              tl: {
                hd: [
                  "code",
                  Curry._1(OTPUtils.OTP.encode, param.code)
                ],
                tl: {
                  hd: [
                    "email",
                    Curry._1(CommonTypes_Email.encode, param.email)
                  ],
                  tl: {
                    hd: [
                      "firstName",
                      Curry._1(CommonTypes_User_Name.FirstName.encode, param.firstName)
                    ],
                    tl: {
                      hd: [
                        "lastName",
                        Curry._1(CommonTypes_User_Name.LastName.encode, param.lastName)
                      ],
                      tl: {
                        hd: [
                          "phoneNumber",
                          CommonTypes_LongPhoneNumber.encode(param.phoneNumber)
                        ],
                        tl: {
                          hd: [
                            "promoCode",
                            Json.Encode.optional(CommonTypes_Worker_ReferralPromoCode.encode, param.referralCode)
                          ],
                          tl: {
                            hd: [
                              "utmCampaign",
                              Json.Encode.optional((function (prim) {
                                      return prim;
                                    }), match.campaign)
                            ],
                            tl: {
                              hd: [
                                "utmContent",
                                Json.Encode.optional((function (prim) {
                                        return prim;
                                      }), match.content)
                              ],
                              tl: {
                                hd: [
                                  "utmMedium",
                                  Json.Encode.optional((function (prim) {
                                          return prim;
                                        }), match.medium)
                                ],
                                tl: {
                                  hd: [
                                    "utmSource",
                                    Json.Encode.optional((function (prim) {
                                            return prim;
                                          }), match.source)
                                  ],
                                  tl: {
                                    hd: [
                                      "utmTerm",
                                      Json.Encode.optional((function (prim) {
                                              return prim;
                                            }), match.term)
                                    ],
                                    tl: {
                                      hd: [
                                        "zipcode",
                                        Curry._1(CommonTypes_ZipCode.encode, param.zipcode)
                                      ],
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function decode$3(param) {
  var match = param.workerSignup;
  if (match !== undefined) {
    return match.jwt;
  }
  
}

var Definition$3 = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  variables: variables$3,
  decode: decode$3
};

var include$3 = Apollo.CreateMutation({
      Raw: Raw$3,
      query: query$3,
      variables: variables$3,
      parse: parse$3,
      decode: decode$3
    });

var SignupProfessional_graphqlMutationAST = include$3.graphqlMutationAST;

var SignupProfessional_mutate = include$3.mutate;

var SignupProfessional_mutateStoreError = include$3.mutateStoreError;

var SignupProfessional_mutateResult = include$3.mutateResult;

var SignupProfessional_mutateResultStore = include$3.mutateResultStore;

var SignupProfessional_mutateAsyncData = include$3.mutateAsyncData;

var SignupProfessional_mutateAsyncResult = include$3.mutateAsyncResult;

var SignupProfessional_mutateAsycResultApolloError = include$3.mutateAsycResultApolloError;

var SignupProfessional = {
  Definition: Definition$3,
  graphqlMutationAST: SignupProfessional_graphqlMutationAST,
  mutate: SignupProfessional_mutate,
  mutateStoreError: SignupProfessional_mutateStoreError,
  mutateResult: SignupProfessional_mutateResult,
  mutateResultStore: SignupProfessional_mutateResultStore,
  mutateAsyncData: SignupProfessional_mutateAsyncData,
  mutateAsyncResult: SignupProfessional_mutateAsyncResult,
  mutateAsycResultApolloError: SignupProfessional_mutateAsycResultApolloError
};

var Raw$4 = {};

var query$4 = "mutation businessLoginOrSignup($phoneNumber: PhoneNumber!, $code: String!)  {\nbusinessLoginOrSignup(input: {phoneNumber: $phoneNumber, code: $code})  {\nbusinessLoginOrSignupResult  {\n...CommonTypes_Business_LoginOrSignupResult   \n}\n\n}\n\n}\n" + CommonTypes_Business_LoginOrSignupResult.query;

function parse$4(value) {
  var value$1 = value.businessLoginOrSignup;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.businessLoginOrSignupResult;
    tmp = {
      businessLoginOrSignupResult: !(value$2 == null) ? CommonTypes_Business_LoginOrSignupResult.verifyArgsAndParse("CommonTypes_Business_LoginOrSignupResult", value$2) : undefined
    };
  }
  return {
          businessLoginOrSignup: tmp
        };
}

function serialize$4(value) {
  var value$1 = value.businessLoginOrSignup;
  var businessLoginOrSignup;
  if (value$1 !== undefined) {
    var value$2 = value$1.businessLoginOrSignupResult;
    var businessLoginOrSignupResult = value$2 !== undefined ? CommonTypes_Business_LoginOrSignupResult.serialize(value$2) : null;
    businessLoginOrSignup = {
      businessLoginOrSignupResult: businessLoginOrSignupResult
    };
  } else {
    businessLoginOrSignup = null;
  }
  return {
          businessLoginOrSignup: businessLoginOrSignup
        };
}

function serializeVariables$4(inp) {
  return {
          phoneNumber: inp.phoneNumber,
          code: inp.code
        };
}

function makeVariables$4(phoneNumber, code, param) {
  return {
          phoneNumber: phoneNumber,
          code: code
        };
}

function variables$4(param) {
  return Json.Encode.object_({
              hd: [
                "phoneNumber",
                CommonTypes_LongPhoneNumber.encode(param.phoneNumber)
              ],
              tl: {
                hd: [
                  "code",
                  Curry._1(OTPUtils.OTP.encode, param.code)
                ],
                tl: /* [] */0
              }
            });
}

function decode$4(param) {
  var match = param.businessLoginOrSignup;
  if (match !== undefined) {
    return match.businessLoginOrSignupResult;
  }
  
}

var Definition$4 = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  variables: variables$4,
  decode: decode$4
};

var include$4 = Apollo.CreateMutation({
      Raw: Raw$4,
      query: query$4,
      variables: variables$4,
      parse: parse$4,
      decode: decode$4
    });

var BusinessLoginOrSignUp_graphqlMutationAST = include$4.graphqlMutationAST;

var BusinessLoginOrSignUp_mutate = include$4.mutate;

var BusinessLoginOrSignUp_mutateStoreError = include$4.mutateStoreError;

var BusinessLoginOrSignUp_mutateResult = include$4.mutateResult;

var BusinessLoginOrSignUp_mutateResultStore = include$4.mutateResultStore;

var BusinessLoginOrSignUp_mutateAsyncData = include$4.mutateAsyncData;

var BusinessLoginOrSignUp_mutateAsyncResult = include$4.mutateAsyncResult;

var BusinessLoginOrSignUp_mutateAsycResultApolloError = include$4.mutateAsycResultApolloError;

var BusinessLoginOrSignUp = {
  Definition: Definition$4,
  graphqlMutationAST: BusinessLoginOrSignUp_graphqlMutationAST,
  mutate: BusinessLoginOrSignUp_mutate,
  mutateStoreError: BusinessLoginOrSignUp_mutateStoreError,
  mutateResult: BusinessLoginOrSignUp_mutateResult,
  mutateResultStore: BusinessLoginOrSignUp_mutateResultStore,
  mutateAsyncData: BusinessLoginOrSignUp_mutateAsyncData,
  mutateAsyncResult: BusinessLoginOrSignUp_mutateAsyncResult,
  mutateAsycResultApolloError: BusinessLoginOrSignUp_mutateAsycResultApolloError
};

var Raw$5 = {};

var query$5 = "mutation businessSignup($businessName: String!, $cityId: Int!, $email: Email!, $firstName: String!, $lastName: String!, $password: String!, $phoneNumber: PhoneNumber!, $promoCode: String, $signupKey: UUID!, $utmCampaign: String, $utmContent: String, $utmMedium: String, $utmSource: String, $utmTerm: String)  {\nbusinessSignup(input: {businessName: $businessName, cityId: $cityId, email: $email, firstName: $firstName, lastName: $lastName, password: $password, phoneNumber: $phoneNumber, promoCode: $promoCode, signupKey: $signupKey, utmCampaign: $utmCampaign, utmContent: $utmContent, utmMedium: $utmMedium, utmSource: $utmSource, utmTerm: $utmTerm})  {\njwt  \n}\n\n}\n";

function parse$5(value) {
  var value$1 = value.businessSignup;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.jwt;
    tmp = {
      jwt: !(value$2 == null) ? Caml_option.some(CommonTypes_Jwt.GraphQL_API.parse(value$2)) : undefined
    };
  }
  return {
          businessSignup: tmp
        };
}

function serialize$5(value) {
  var value$1 = value.businessSignup;
  var businessSignup;
  if (value$1 !== undefined) {
    var value$2 = value$1.jwt;
    var jwt = value$2 !== undefined ? Curry._1(CommonTypes_Jwt.GraphQL_API.serialize, Caml_option.valFromOption(value$2)) : null;
    businessSignup = {
      jwt: jwt
    };
  } else {
    businessSignup = null;
  }
  return {
          businessSignup: businessSignup
        };
}

function serializeVariables$5(inp) {
  var a = inp.promoCode;
  var a$1 = inp.utmCampaign;
  var a$2 = inp.utmContent;
  var a$3 = inp.utmMedium;
  var a$4 = inp.utmSource;
  var a$5 = inp.utmTerm;
  return {
          businessName: inp.businessName,
          cityId: inp.cityId,
          email: inp.email,
          firstName: inp.firstName,
          lastName: inp.lastName,
          password: inp.password,
          phoneNumber: inp.phoneNumber,
          promoCode: a !== undefined ? a : undefined,
          signupKey: inp.signupKey,
          utmCampaign: a$1 !== undefined ? a$1 : undefined,
          utmContent: a$2 !== undefined ? a$2 : undefined,
          utmMedium: a$3 !== undefined ? a$3 : undefined,
          utmSource: a$4 !== undefined ? a$4 : undefined,
          utmTerm: a$5 !== undefined ? a$5 : undefined
        };
}

function makeVariables$5(businessName, cityId, email, firstName, lastName, password, phoneNumber, promoCode, signupKey, utmCampaign, utmContent, utmMedium, utmSource, utmTerm, param) {
  return {
          businessName: businessName,
          cityId: cityId,
          email: email,
          firstName: firstName,
          lastName: lastName,
          password: password,
          phoneNumber: phoneNumber,
          promoCode: promoCode,
          signupKey: signupKey,
          utmCampaign: utmCampaign,
          utmContent: utmContent,
          utmMedium: utmMedium,
          utmSource: utmSource,
          utmTerm: utmTerm
        };
}

function variables$5(param) {
  var match = param.utmParams;
  return Json.Encode.object_({
              hd: [
                "businessName",
                param.businessName
              ],
              tl: {
                hd: [
                  "cityId",
                  Curry._1(CommonTypes_City.Id.encode, param.city.id)
                ],
                tl: {
                  hd: [
                    "email",
                    Curry._1(CommonTypes_Email.encode, param.email)
                  ],
                  tl: {
                    hd: [
                      "firstName",
                      Curry._1(CommonTypes_User_Name.FirstName.encode, param.firstName)
                    ],
                    tl: {
                      hd: [
                        "lastName",
                        Curry._1(CommonTypes_User_Name.LastName.encode, param.lastName)
                      ],
                      tl: {
                        hd: [
                          "password",
                          param.password
                        ],
                        tl: {
                          hd: [
                            "phoneNumber",
                            CommonTypes_LongPhoneNumber.encode(param.phoneNumber)
                          ],
                          tl: {
                            hd: [
                              "promoCode",
                              Json.Encode.optional(CommonTypes_Business_PromoCode.encode, param.promoCode)
                            ],
                            tl: {
                              hd: [
                                "signupKey",
                                CommonTypes_Guid.encode(param.signupKey)
                              ],
                              tl: {
                                hd: [
                                  "utmCampaign",
                                  Json.Encode.optional((function (prim) {
                                          return prim;
                                        }), match.campaign)
                                ],
                                tl: {
                                  hd: [
                                    "utmContent",
                                    Json.Encode.optional((function (prim) {
                                            return prim;
                                          }), match.content)
                                  ],
                                  tl: {
                                    hd: [
                                      "utmMedium",
                                      Json.Encode.optional((function (prim) {
                                              return prim;
                                            }), match.medium)
                                    ],
                                    tl: {
                                      hd: [
                                        "utmSource",
                                        Json.Encode.optional((function (prim) {
                                                return prim;
                                              }), match.source)
                                      ],
                                      tl: {
                                        hd: [
                                          "utmTerm",
                                          Json.Encode.optional((function (prim) {
                                                  return prim;
                                                }), match.term)
                                        ],
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function decode$5(param) {
  var match = param.businessSignup;
  if (match !== undefined) {
    return match.jwt;
  }
  
}

var Definition$5 = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5,
  variables: variables$5,
  decode: decode$5
};

var include$5 = Apollo.CreateMutation({
      Raw: Raw$5,
      query: query$5,
      variables: variables$5,
      parse: parse$5,
      decode: decode$5
    });

var SignupBusiness_graphqlMutationAST = include$5.graphqlMutationAST;

var SignupBusiness_mutate = include$5.mutate;

var SignupBusiness_mutateStoreError = include$5.mutateStoreError;

var SignupBusiness_mutateResult = include$5.mutateResult;

var SignupBusiness_mutateResultStore = include$5.mutateResultStore;

var SignupBusiness_mutateAsyncData = include$5.mutateAsyncData;

var SignupBusiness_mutateAsyncResult = include$5.mutateAsyncResult;

var SignupBusiness_mutateAsycResultApolloError = include$5.mutateAsycResultApolloError;

var SignupBusiness = {
  Definition: Definition$5,
  graphqlMutationAST: SignupBusiness_graphqlMutationAST,
  mutate: SignupBusiness_mutate,
  mutateStoreError: SignupBusiness_mutateStoreError,
  mutateResult: SignupBusiness_mutateResult,
  mutateResultStore: SignupBusiness_mutateResultStore,
  mutateAsyncData: SignupBusiness_mutateAsyncData,
  mutateAsyncResult: SignupBusiness_mutateAsyncResult,
  mutateAsycResultApolloError: SignupBusiness_mutateAsycResultApolloError
};

exports.CheckEmailAvailable = CheckEmailAvailable;
exports.CheckPhoneNumberAvailable = CheckPhoneNumberAvailable;
exports.SendVerifyCode = SendVerifyCode;
exports.SignupProfessional = SignupProfessional;
exports.BusinessLoginOrSignUp = BusinessLoginOrSignUp;
exports.SignupBusiness = SignupBusiness;
/* include Not a pure module */
